module.exports = __webpack_public_path__ + "c705b771725d538fb74caa680d795e07.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/signature/signature-autumn-2012-page-003.jpg
 ** module id = 470
 ** module chunks = 0
 **/